import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { FileService } from 'app/services/file.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'environments/environment';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
  selector: 'app-drake-image-preview',
  templateUrl: './drake-image-preview.component.html',
  styleUrls: ['./drake-image-preview.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, HttpClientModule, TranslocoPipe],
  providers: [TranslocoPipe]
})
export class DrakeImagePreviewComponent implements OnChanges {

  @Input() fileId: string = null;
  @Input() width: string = "100%";
  @Input() height: string = "100%";
  @Input() cssClasses: string = "";
  fileName: string = null;
  fileContentBase64: string = null;
  dataUrl: SafeUrl = null;
  extension: string = null;
  previewType: string = null;

  constructor(private fileService: FileService, private sanitizer: DomSanitizer) {
    this.dataUrl = '/assets/images/loading.gif'
  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes)
    if (changes.fileId?.currentValue) {
      var x = this.fileService.readFileAsBase64String(this.fileId)
      //console.log(x)
      x.subscribe((res: any) => {
          if (res)
            this.dataUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.dataUrl);
        
      });
    }
  }
}
